export enum IDMinorAssistance {
  Padre = '1',
  Madre = '2',
  Entrambi = '3',
  Tutore = '4',
  Curatore = '5',
}
